import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { CoverArtsResponse } from './types';

export const getAllCoverArts = async ({ artistId }: { artistId: string }) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/cover-arts/all`;
  const response = await api.executeGetRequest<ObjectResponse<CoverArtsResponse>>(url);

  return response?.data;
};
